import { ChangeEvent, FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import classNames from 'classnames'
import { Checkbox, Field } from '@matillion/component-library'

import classes from 'components/Form/Form.module.scss'
import { CreateProjectFormikValueTypes } from 'modules/Projects/CreateProject/CreateProjectForm'

const Ssl: FunctionComponent = () => {
  const { values, setFieldValue } =
    useFormikContext<CreateProjectFormikValueTypes>()
  const { t } = useTranslation()

  return (
    <div data-testid={`${values.type.toLowerCase()}-credentials-ssl`}>
      <Field
        title={t('fields.ssl.title')}
        name="ssl"
        inputComponent={Checkbox}
        data-testid={`${values.type.toLowerCase()}-credentials-ssl-input-checkbox`}
        labelDataTestId={`${values.type.toLowerCase()}-credentials-ssl-input-label`}
        value={values.ssl}
        checked={values.ssl}
        placeholder={t('fields.ssl.placeholderText')}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setFieldValue('ssl', e.target.checked)
        }}
        className={classNames(classes.Form__SpacingStyles)}
        supportText={t('fields.ssl.supportText')}
      />
    </div>
  )
}

export default Ssl
